window.$ = window.jQuery = require('jquery');

require('jquery-viewport-checker');
require('./simple-lightbox');
require('bootstrap');
require('leaflet');
require('slick-carousel');